import React from "react";

const MarkSheetFormatTwo = ({ marksheet }) => {
  const {
    report_info = {},
    done_subjects = [],
    marks_collection = {}
  } = marksheet || {};

  const studentInfo = marks_collection?.student_info || [];

  const SubjectHead = ({ subject }) => (
    <>
      {subject?.done_papers?.map((paper, idx) => (
        <td key={idx}>&nbsp;P{paper.paper_code?.split("/")?.[1] || ""}&nbsp;</td>
      ))}
      <td>GD</td>
    </>
  );

  const MarkHead = ({ studentMarks = {}, donePapers = [], subjectId }) => {
    const total_mark = studentMarks?.total_mark || {};
    const gradeLabel = studentMarks?.advanced_grade_label || {};

    return (
      <>
        {donePapers.map((paper, idx) => (
          <td key={idx} style={{ textAlign: "center" }}>
            {total_mark?.[paper.paper_id] ?? ""}
          </td>
        ))}
        <td
          style={
            gradeLabel[subjectId]
              ? {
                  backgroundColor: "#000000",
                  color: "#FFFFFF",
                  fontWeight: "bold",
                  textAlign: "center"
                }
              : { textAlign: "center" }
          }
        >
          {gradeLabel?.[subjectId] || ""}
        </td>
      </>
    );
  };

  if (!Array.isArray(studentInfo)) return null;

  return (
    <table
      width="100%"
      border="1"
      className="Reports"
      style={{ fontSize: "12px" }}
      cellSpacing="0"
      cellPadding="0"
    >
      <caption>{report_info?.title || "Marksheet"}</caption>
      <thead>
        <tr>
          <th>NO</th>
          <th>NAMES</th>
          {done_subjects.map((subject, idx) => (
            <th
              key={idx}
              colSpan={(subject?.total_papers || 0) + 1}
              style={{ textAlign: "center" }}
            >
              {subject?.subject_info?.abbreviation}
            </th>
          ))}
          <th style={{ textAlign: "center" }}>PTS</th>
        </tr>
      </thead>
      <tbody>
        {/* Subject Paper Headers */}
        <tr
          style={{
            backgroundColor: "#000000",
            color: "#FFFFFF",
            fontWeight: "bold",
            textAlign: "center"
          }}
        >
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          {done_subjects.map((subject, idx) => (
            <SubjectHead key={idx} subject={subject} />
          ))}
          <td>&nbsp;</td>
        </tr>

        {/* Student Marks Rows */}
        {studentInfo.map((student, idx) => {
          const studentId = student.id;
          const studentMarks = marks_collection[studentId] || {};

          return (
            <tr key={studentId}>
              <td>{idx + 1}</td>
              <td>{student.full_name}</td>

              {done_subjects.map((subject, i) => {
                const subjectId = subject?.subject_info?.subject_id;
                return (
                  <MarkHead
                    key={i}
                    studentMarks={studentMarks[subjectId]}
                    donePapers={subject.done_papers}
                    subjectId={subjectId}
                  />
                );
              })}

              <td style={{ textAlign: "center", fontWeight: "bold" }}>
                {marks_collection[studentId]?.advanced_points}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default MarkSheetFormatTwo;
